import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import './index.scss';

import Header from '../components/Header'
import Footer from '../components/Footer'

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="Dapis"
      meta={[
        { name: 'description', content: 'Dapis.io' },
        { name: 'keywords', content: 'dapis.io, web3, saas, dapis, decentralized api' },
      ]}
    >
    <link href="https://fastcdn.org/Animate.css/3.4.0/animate.min.css" rel="stylesheet" />
    <script src="https://cdnjs.cloudflare.com/ajax/libs/wow/1.1.2/wow.min.js" type="text/javascript" />
    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css" integrity="sha384-B4dIYHKNBt8Bc12p+WXckhzcICo0wtJAoU8YZTY5qE0Id1GSseTk6S+L3BlXeVIU" crossorigin="anonymous" />
    <script type="text/javascript">{`
      window.productHuntUpcoming = {
        appId: 8283,
        position: 'bottomLeft',
      };

      (function(doc, scr, src, a, b) {
        a = doc.createElement(scr);
        b = doc.getElementsByTagName(scr)[0];
        a.async = true;
        a.src = src;
        b.parentNode.insertBefore(a, b);
      })(document, 'script', 'https://assets.producthunt.com/assets/upwigloader.js');
  `}</script>

    </Helmet>
    <div className="main">
      <Header />
      {children()}
      <Footer />
    </div>
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js